import { ArrowRight, Clock3, DoorOpen, UsersRound } from "lucide-react";
import { Link } from "react-router-dom";

import type { Quest } from "../data/quests";
import { QuestIcon } from "./QuestIcon";
import "./QuestExplanation.css";

export function QuestExplanation({ quest, joinHref }: { quest: Quest; joinHref: string }) {
  const headingId = "quest-explanation-title";

  return <section className={`join-card hub-join-card quest-explanation quest-explanation-${quest.tone}`} aria-labelledby={headingId}>
    <header className="quest-explanation-heading">
      <div><span className="card-kicker">Your next quest</span><h2 id={headingId} tabIndex={-1}>{quest.title}</h2></div>
      <span className="quest-explanation-icon"><QuestIcon src={quest.iconSrc} /></span>
    </header>
    <p className="quest-explanation-intro">{quest.description}</p>
    <dl className="quest-explanation-meta">
      <div><dt><UsersRound size={13} aria-hidden="true" /> People</dt><dd>{quest.players}</dd></div>
      <div><dt><Clock3 size={13} aria-hidden="true" /> Pace</dt><dd>{quest.timing}</dd></div>
    </dl>
    <ol className="quest-explanation-steps" aria-label="How to play">
      {quest.steps.map((step, index) => <li key={step.title}>
        <span className="quest-explanation-step-number" aria-hidden="true">0{index + 1}</span>
        <div><h3>{step.title}</h3><p>{step.description}</p></div>
      </li>)}
    </ol>
    <aside className="quest-explanation-note"><strong>The little details</strong><p>{quest.details}</p></aside>
    <div className="quest-explanation-actions">
      <Link to={quest.hostPath} className="quest-explanation-host"><span>Host {quest.title}</span><ArrowRight size={17} aria-hidden="true" /></Link>
      <Link to={joinHref} className="quest-explanation-join"><DoorOpen size={15} aria-hidden="true" /> Join a room</Link>
    </div>
  </section>;
}
